export default __webpack_public_path__ + "static/media/BSM_Store_Icon.697cd017.svg";